<template>
	<div>
		<p>
			Aufgrund der letzten Schritte mit <b>{{ applicantName }}</b>, besteht seitens <b>{{ companyName }}</b>
			Interesse an einer Zusammenarbeit.
		</p>
		<p>
			Es folgen nun - soweit <b>{{ applicantName }}</b> auch interessiert ist - die Verhandlungen über
			die näheren Details, wie Gehalt, Beginn der Tätigkeit und andere Fragen.
		</p>
		<p><b>{{ applicantName }}, erhält folgende Nachricht von dir:</b></p>
		<InfoBox class="my-3" :with-icon="false" type="purple-lightest">
			<nl2br tag="div" :text="text" />
		</InfoBox>
		<p>
			Sobald <b>{{ applicantName }}</b> sein Interesse mitteilt, erhältst du für die nächsten Schritte die
			Kontaktdaten von <b>{{ applicantName }}</b>, wie E-Mail Adresse und Mobilnummer.
		</p>
	</div>
</template>

<script>
import InfoBox from "@/vue/common/InfoBox";
import Nl2br from 'vue-nl2br'

export default {

	components: {
		InfoBox,
		Nl2br,
	},

	props: {
		applicantName: {
			type: String,
			required: true,
		},
		companyName: {
			type: String,
			required: true,
		},
		text: {
			type: String,
			required: true,
		}
	}
}
</script>

